import {
    Bars4Icon,
    CalendarIcon,
    ClockIcon,
    PhotoIcon,
    TableCellsIcon,
    ViewColumnsIcon,
} from '@heroicons/react/24/outline';

import { useState } from "react";

export function Login() {

    return (
        <>
            <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <img
                        alt="Curb-Ease Logo"
                        src={require('../assets/curb-ease-logo.jpg')}
                        className="mx-auto h-10 w-auto dark:hidden"
                    />
                    <img
                        alt="Curb-Ease Logo"
                        src={require('../assets/curb-ease-logo.jpg')}
                        className="mx-auto hidden h-10 w-auto dark:block"
                    />
                    <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900 dark:text-white">
                        Sign in to your account
                    </h2>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
                    <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10">
                        <form action="#" method="POST" className="space-y-6">
                            <div>
                                <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900 dark:text-white">
                                    Email address
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        required
                                        autoComplete="email"
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
                                    />
                                </div>
                            </div>

                            <div>
                                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900 dark:text-white">
                                    Password
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        required
                                        autoComplete="current-password"
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-700 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-green-600"
                                    />
                                </div>
                            </div>

                            <div className="flex items-center justify-between">
                                {/* <div className="flex gap-3">
                                    <div className="flex h-6 shrink-0 items-center">
                                        <div className="group grid size-4 grid-cols-1">
                                            <input
                                                id="remember-me"
                                                name="remember-me"
                                                type="checkbox"
                                                className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-green-700 checked:bg-green-700 indeterminate:border-green-700 indeterminate:bg-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 dark:border-white/10 dark:bg-white/5 dark:checked:border-green-600 dark:checked:bg-green-600 dark:indeterminate:border-green-600 dark:indeterminate:bg-green-600 dark:focus-visible:outline-green-600 forced-colors:appearance-auto"
                                            />
                                            <svg
                                                fill="none"
                                                viewBox="0 0 14 14"
                                                className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25 dark:group-has-[:disabled]:stroke-white/25"
                                            >
                                                <path
                                                    d="M3 8L6 11L11 3.5"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="opacity-0 group-has-[:checked]:opacity-100"
                                                />
                                                <path
                                                    d="M3 7H11"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="opacity-0 group-has-[:indeterminate]:opacity-100"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <label htmlFor="remember-me" className="block text-sm/6 text-gray-900 dark:text-white">
                                        Remember me
                                    </label>
                                </div> */}

                                <div className="text-sm/6">
                                    <a
                                        href="#"
                                        className="font-semibold text-green-700 hover:text-green-700 dark:text-green-600 dark:hover:text-green-500"
                                    >
                                        Forgot password?
                                    </a>
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="flex w-full justify-center rounded-md bg-green-700 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700 dark:bg-green-600 dark:shadow-none dark:hover:bg-green-500 dark:focus-visible:outline-green-600"
                                >
                                    Sign in
                                </button>
                            </div>
                        </form>

                        <div>
                            <div className="mt-10 flex items-center gap-x-6">
                                <div className="w-full flex-1 border-t border-gray-200 dark:border-white/10" />
                                <p className="text-nowrap text-sm/6 font-medium text-gray-900 dark:text-white">Or continue with</p>
                                <div className="w-full flex-1 border-t border-gray-200 dark:border-white/10" />
                            </div>

                            <div className="mt-6 grid grid-cols-2 gap-4">
                                <a
                                    href="/api/auth/google"
                                    className="flex w-full items-center justify-center gap-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:ring-transparent dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                                >
                                    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
                                        <path
                                            d="M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25527 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z"
                                            fill="#EA4335"
                                        />
                                        <path
                                            d="M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z"
                                            fill="#4285F4"
                                        />
                                        <path
                                            d="M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z"
                                            fill="#FBBC05"
                                        />
                                        <path
                                            d="M12.0004 24.0001C15.2404 24.0001 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2654 14.29L1.27539 17.385C3.25539 21.31 7.3104 24.0001 12.0004 24.0001Z"
                                            fill="#34A853"
                                        />
                                    </svg>
                                    <span className="text-sm/6 font-semibold">Google</span>
                                </a>

                                <a
                                    href="#"
                                    className="flex w-full items-center justify-center gap-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:ring-transparent dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                                >
                                    <svg
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                        aria-hidden="true"
                                        className="h-5 w-5 fill-[#24292F] dark:fill-white"
                                    >
                                        <path
                                            d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"
                                            clipRule="evenodd"
                                            fillRule="evenodd"
                                        />
                                    </svg>
                                    <span className="text-sm/6 font-semibold">GitHub</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <p className="mt-10 text-center text-sm/6 text-gray-500 dark:text-gray-400">
                        Not a member?{' '}
                        <a
                            href="#"
                            className="font-semibold text-green-700 hover:text-green-600 dark:text-green-500 dark:hover:text-green-400"
                        >
                            Start a 14 day free trial
                        </a>
                    </p>
                </div>
            </div>
        </>
    )
};

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
};

export function ManageSubs({ userEmail }) {
    const [status, setStatus] = useState(`Logged as ${userEmail}`);
    const VAPID_PUBLIC_KEY = "BHZdzj07z1Fys5U2ReTDj9WXTrWVB89pfLPhskl9n8xHV-NqSNGZJuOSqRumu2Ur8imoLKA-hsaffqolNV4t-3c";

    function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        const rawData = window.atob(base64);
        return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
    };

    async function subscribe() {
        try {
            const registration = await navigator.serviceWorker.ready;
            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
            });

            await fetch("/api/push/subscribe", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(subscription),
            });

            setStatus("Subscribed successfully");
        } catch (err) {
            console.error(err);
            setStatus('Subscription failed');
        }
    };

    async function unsubscribe() {
        try {
            const registration = await navigator.serviceWorker.ready;
            const subscription = await registration.pushManager.getSubscription();

            if (subscription) {
                await subscription.unsubscribe();
            }

            await fetch("/api/push/unsubscribe", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(subscription),
            });

            setStatus("Unsubscribed successfully");
        } catch (err) {
            console.error(err);
            setStatus("Unsubscribe failed");
        }
    };

    async function testNotification() {
        try {
            const registration = await navigator.serviceWorker.ready;
            const subscription = await registration.pushManager.getSubscription();
            await fetch("/api/push/test", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(subscription),
            });
            setStatus("Test notification sent");
        } catch (err) {
            console.error(err);
            setStatus("Test failed");
        }
    };

    const items = [
        {
            title: 'Create a Subscription to notifications',
            description: 'Subscribe your browser to calls notifications once it is authorized with Google admin account',
            icon: Bars4Icon,
            background: 'bg-pink-500',
            action: subscribe,
        },
        {
            title: 'Test a Subscription to notifications',
            description: 'Send a test notification. Be sure to enable notifications for that web site',
            icon: CalendarIcon,
            background: 'bg-yellow-500',
            action: testNotification,
        },
        {
            title: 'Unsubscribe from notifications',
            description: 'You can always re-subscribe to notifications when needed',
            icon: PhotoIcon,
            background: 'bg-green-500',
            action: unsubscribe,
        },
        // {
        //     title: 'Create a Board',
        //     description: 'Track tasks in different stages of your project.',
        //     icon: ViewColumnsIcon,
        //     background: 'bg-blue-500',
        // },
        // {
        //     title: 'Create a Spreadsheet',
        //     description: 'Lots of numbers and things — good for nerds.',
        //     icon: TableCellsIcon,
        //     background: 'bg-indigo-500',
        // },
        // {
        //     title: 'Create a Timeline',
        //     description: 'Get a birds-eye-view of your procrastination.',
        //     icon: ClockIcon,
        //     background: 'bg-purple-500',
        // },
    ];

    const handleClick = (e, action) => {
        e.preventDefault();
        action();
    };


    return (
        <div className="overflow-hidden bg-white shadow sm:rounded-lg dark:bg-gray-800/50 dark:shadow-none dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10">
            <div className="px-4 py-5 sm:p-6">
                <h2 className="text-base font-semibold text-gray-900 dark:text-white">Dashboard</h2>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                    {status}
                </p>
                <ul
                    role="list"
                    className="mt-6 grid grid-cols-1 gap-6 border-y border-gray-200 py-6 sm:grid-cols-2 dark:border-white/10"
                >
                    {items.map((item, itemIdx) => (
                        <li key={itemIdx} className="flow-root">
                            <div className="relative -m-2 flex items-center space-x-4 rounded-xl p-2 focus-within:outline focus-within:outline-2 focus-within:outline-indigo-600 hover:bg-gray-50 dark:focus-within:outline-indigo-500 dark:hover:bg-white/5">
                                <div
                                    className={classNames(item.background, 'flex size-16 shrink-0 items-center justify-center rounded-lg')}
                                >
                                    <item.icon aria-hidden="true" className="size-6 text-white" />
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-900 dark:text-white">
                                        <a
                                            href="#"
                                            role="button"
                                            onClick={(e) => handleClick(e, item.action)}
                                            className="focus:outline-none"
                                        >
                                            <span aria-hidden="true" className="absolute inset-0" />
                                            <span>{item.title}</span>
                                            <span aria-hidden="true"> &rarr;</span>
                                        </a>
                                    </h3>
                                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{item.description}</p>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
                <div className="mt-4 flex">
                    <a
                        href="/api/auth/google"
                        className="text-sm font-medium text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300"
                    >
                        Click here to change user
                        <span aria-hidden="true"> &rarr;</span>
                    </a>
                </div>
            </div>
        </div>
    )
};